document.addEventListener('DOMContentLoaded', function() {

    // Get shared utilities from club-customization-util.js
    const {
        _populateSelectOptions,
        _escapeHtmlAttribute,
        _dropdownSvg,
        fetchCollectionFeed,
        initModelSelector
    } = window.clubCustomizationUtils || {};

    const playingLengths = {
        // "Driver": ['44"', '44.25"', '44.5"', '44.75"', '45"', '45.25"', '45.5"', '45.75"', '46"', '46.25"', '46.5"', '46.75"', '47"'],
        // "Mini Driver": ['42"', '42.25"', '42.5"', '42.75"', '43"', '43.25"', '43.5"', '43.75"', '44"', '44.25"', '44.5"', '44.75"', '45"', '45.25"', '45.5"', '45.75"'],
        // "3 Wood": ['40.5"', '40.75"', '41"', '41.25"', '41.5"', '41.75"', '42"', '42.25"', '42.5"', '42.75"', '43"', '43.25"', '43.5"', '43.75"', '44"', '44.25"', '44.5"', '44.75"'],
        // "5 Wood": ['40.5"', '40.75"', '41"', '41.25"', '41.5"', '41.75"', '42"', '42.25"', '42.5"', '42.75"', '43"', '43.25"', '43.5"', '43.75"', '44"', '44.25"', '44.5"', '44.75"'],
        // "7 Wood": ['40.5"', '40.75"', '41"', '41.25"', '41.5"', '41.75"', '42"', '42.25"', '42.5"', '42.75"', '43"', '43.25"', '43.5"', '43.75"', '44"', '44.25"', '44.5"', '44.75"'],
        // "9 Wood": ['40.5"', '40.75"', '41"', '41.25"', '41.5"', '41.75"', '42"', '42.25"', '42.5"', '42.75"', '43"', '43.25"', '43.5"', '43.75"', '44"', '44.25"', '44.5"', '44.75"'],
        // "2 Hybrid": ['37"', '37.25"', '37.5"', '37.75"', '38"', '38.25"', '38.5"', '38.75"', '39"', '39.25"', '39.5"', '39.75"', '40"', '40.25"', '40.5"', '40.75"', '41"', '41.25"', '41.5"', '41.75"', '42"'],
        // "3 Hybrid": ['37"', '37.25"', '37.5"', '37.75"', '38"', '38.25"', '38.5"', '38.75"', '39"', '39.25"', '39.5"', '39.75"', '40"', '40.25"', '40.5"', '40.75"', '41"', '41.25"', '41.5"', '41.75"', '42"'],
        // "4 Hybrid": ['37"', '37.25"', '37.5"', '37.75"', '38"', '38.25"', '38.5"', '38.75"', '39"', '39.25"', '39.5"', '39.75"', '40"', '40.25"', '40.5"', '40.75"', '41"', '41.25"', '41.5"', '41.75"', '42"'],
        // "5 Hybrid": ['37"', '37.25"', '37.5"', '37.75"', '38"', '38.25"', '38.5"', '38.75"', '39"', '39.25"', '39.5"', '39.75"', '40"', '40.25"', '40.5"', '40.75"', '41"', '41.25"', '41.5"', '41.75"', '42"'],
        // "6 Hybrid": ['37"', '37.25"', '37.5"', '37.75"', '38"', '38.25"', '38.5"', '38.75"', '39"', '39.25"', '39.5"', '39.75"', '40"', '40.25"', '40.5"', '40.75"', '41"', '41.25"', '41.5"', '41.75"', '42"'],
        // "Iron": ['-1.5"', '-1.25"', '-1"', '-0.75"', '-0.5"', '-0.25"', '(Standard) +/-0"', '+0.25"', '+0.5"', '+0.75"', '+1"', '+1.25"', '+1.5"'],
        // "Wedge": ['-1.5"', '-1.25"', '-1"', '-0.75"', '-0.5"', '-0.25"', '(Standard) +/-0"', '+0.25"', '+0.5"', '+0.75"', '+1"', '+1.25"', '+1.5"'],
        // "Putter": ['32"', '32.5"', '33"', '33.5"', '34"', '34.5"', '35"', '35.5"', '36"', '36.5"', '37"', '37.5"', '38"', '38.5"', '39"'],
        "default": ['-1.5"', '-1.25"', '-1"', '-0.75"', '-0.5"', '-0.25"', '(Standard) +/-0"', '+0.25"', '+0.5"', '+0.75"', '+1"', '+1.25"', '+1.5"', 'Custom (add in notes)'],
    }

    // Custom Toggle Handler with History API
    const toggleButtons = document.querySelectorAll('.custom-toggle .toggle-option');
    const prebuiltForm = document.querySelector('.prebuilt-form');
    const customForm = document.querySelector('.club-customization-form');
    const customizationFormContainer = document.querySelector('.customization-form');

    // Normalize customization mode to be case-insensitive
    const rawCustomizationMode = customizationFormContainer?.getAttribute('data-customization-mode') || 'Custom/Prebuilt';
    const customizationMode = (() => {
        const normalized = rawCustomizationMode.toLowerCase().trim();
        if (normalized === 'prebuilt only') return 'Prebuilt Only';
        if (normalized === 'custom only') return 'Custom Only';
        if (normalized === 'none' ) return 'None';
        return 'Custom/Prebuilt'; // Default for any other value including 'custom/prebuilt'
    })();

    // Flag to prevent circular updates during variant changes
    let isUpdatingFromVariantChange = false;

    // ============================================================================
    // PRIVATE HELPER FUNCTIONS
    // ============================================================================

    /**
     * Set quantity input value and dispatch change event
     * @private
     */
    function _setQuantity(value) {
        const quantityInput = document.querySelector('input[name="quantity"]');
        if (quantityInput) {
            quantityInput.value = value;
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    /**
     * Find and select variant input by value
     * @private
     */
    function _selectVariant(value, name = null) {
        const selector = name
            ? `[data-variant-input][name="${name}"][value="${value}"]`
            : `[data-variant-input][value="${value}"]`;
        const variantInput = document.querySelector(selector);
        if (variantInput) {
            variantInput.checked = true;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
            return true;
        }
        return false;
    }


    /**
     * Sync radio button groups (one direction)
     * @private
     * @param {boolean} dispatchEvent - Whether to dispatch change event on target
     */
    function _syncRadioGroups(sourceRadios, targetRadios, onChangeCallback = null, dispatchEvent = true) {
        sourceRadios.forEach(radio => {
            radio.addEventListener('change', function() {
                if (this.checked) {
                    targetRadios.forEach(targetRadio => {
                        if (targetRadio.value === this.value) {
                            targetRadio.checked = true;
                            if (dispatchEvent) {
                                targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                        }
                    });
                    if (onChangeCallback) onChangeCallback();
                }
            });
        });
    }

    /**
     * Get checked radio value from a radio group
     * @private
     */
    function _getCheckedRadioValue(radios) {
        const checkedRadio = Array.from(radios).find(r => r.checked);
        return checkedRadio ? checkedRadio.value : '';
    }

    /**
     * Set radio button checked state by value
     * @private
     */
    function _setRadioByValue(radios, value) {
        radios.forEach(radio => {
            radio.checked = (radio.value === value);
        });
    }

    // Note: _populateSelectOptions is now in club-customization-util.js

    /**
     * Update element display and form inputs state
     * @private
     */
    function _updateFormState(showElement, hideElement, enableElement, disableElement) {
        if (showElement) {
            showElement.style.display = 'block';
            if (enableElement !== false) enableFormInputs(showElement);
        }
        if (hideElement) {
            hideElement.style.display = 'none';
            if (disableElement !== false) disableFormInputs(hideElement);
        }
    }

    /**
     * Sync select element with variant inputs (bidirectional)
     * @private
     */
    function _syncSelectWithVariant(selectElement, variantName, onChangeCallback = null) {
        if (!selectElement) return;


        // Sync: Select -> Variant
        selectElement.addEventListener('change', function() {
            const selectedValue = this.value;
            if (!selectedValue) return;

            _selectVariant(selectedValue, variantName);
            
            setTimeout(() => {  
            }, 100);

            if (onChangeCallback) onChangeCallback();
        });
    }

    /**
     * Get the current form mode based on customization settings and URL
     * @returns {string} 'prebuilt' or 'custom'
     */
    function getCurrentMode() {
        // Check customization mode restrictions first
        if (customizationMode === 'Prebuilt Only') {
            return 'prebuilt';
        } else if (customizationMode === 'Custom Only') {
            return 'custom';
        }

        // For Custom/Prebuilt mode, check URL parameter
        const urlParams = new URLSearchParams(window.location.search);
        const customParam = urlParams.get('custom');

        // Default to 'custom' if no parameter is set
        return customParam === 'prebuilt' ? 'prebuilt' : 'custom';
    }

    /**
     * Set the URL parameter for the current mode
     * @param {string} mode - 'prebuilt' or 'custom'
     */
    function setUrlMode(mode) {
        const url = new URL(window.location.href);
        url.searchParams.set('custom', mode);
        window.history.replaceState({}, '', url.toString());
    }

    /**
     * Update form visibility based on current mode
     */
    function updateFormVisibility() {
        const currentMode = getCurrentMode();

        // Hide/show toggle buttons based on customization mode
        if (customizationMode === 'Custom Only' || customizationMode === 'Prebuilt Only') {
            toggleButtons.forEach(button => button.style.display = 'none');
        } else {
            toggleButtons.forEach(button => button.style.display = '');
        }

        // Update toggle button states
        toggleButtons.forEach(button => {
            const toggleValue = button.getAttribute('data-toggle');
            if (toggleValue === currentMode) {
                button.classList.add('active');
            } else {
                button.classList.remove('active');
            }
        });

        // Show/hide forms and update state
        if (currentMode === 'prebuilt') {
            // Show prebuilt, hide custom
            _updateFormState(prebuiltForm, customForm);

            // Select first Set Makeup option and trigger variant change
            const setMakeupRadios = document.querySelectorAll('input[name="Set Makeup"][data-variant-input]');
            const currentOption = document.querySelector('input[name="Set Makeup"][data-variant-input]:checked');

            // Get the first non-Custom option
            const firstNonCustomRadio = Array.from(setMakeupRadios).find(radio => radio.value !== 'Custom');

            // Only set first option if currently selected is Custom
            if (firstNonCustomRadio && currentOption && currentOption.value === "Custom") {
                firstNonCustomRadio.checked = true;
                firstNonCustomRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }

            _setQuantity(1);

        } else {
            // Show custom, hide prebuilt
            _updateFormState(customForm, prebuiltForm);
            _selectVariant("Custom");

            // Update quantity after a brief delay to ensure form is ready
            setTimeout(() => {
                updateCustomQuantity();
            }, 50);
        }

        // Update payment buttons visibility after form visibility changes
        if (typeof updatePaymentButtonsVisibility === 'function') {
            updatePaymentButtonsVisibility();
        }

        // Clean hidden form field names to prevent submission
        if (typeof cleanHiddenFormFields === 'function') {
            cleanHiddenFormFields();
        }
    }

    // Helper function to update quantity for custom form
    function updateCustomQuantity() {
        const clubNumberCheckboxes = document.querySelectorAll('input[name="properties[Club Numbers][]"]');

        // If no club number checkboxes exist or none are checked, set to 1
        if (!clubNumberCheckboxes.length) {
            _setQuantity(1);
            return;
        }

        const checkedCount = Array.from(clubNumberCheckboxes).filter(cb => cb.checked).length;
        _setQuantity(checkedCount > 0 ? checkedCount : 1);
    }

    /**
     * Get the base unit price from the current variant in data-variant-json
     */
    function getBaseUnitPrice() {
        // First, try to get from the currently selected variant
        const variantInput = document.querySelector('[name="id"]');

        if (variantInput) {
            const variantId = variantInput.value;

            if (variantId) {
                // Try to get variant data from the product JSON
                const variantJsonEl = document.querySelector('[data-variant-json]');
                if (variantJsonEl) {
                    try {
                        const variants = JSON.parse(variantJsonEl.textContent);
                        const currentVariant = variants.find(v => v.id == variantId);
                        if (currentVariant && currentVariant.price) {
                            return currentVariant.price; // Already in cents
                        }
                    } catch (e) {
                        console.error('Error parsing variant JSON:', e);
                    }
                }
            }
        }

        // Fallback: Try to get from the current variant JSON element
        const currentVariantJsonEl = document.querySelector('[data-current-variant-json]');
        if (currentVariantJsonEl) {
            try {
                const currentVariant = JSON.parse(currentVariantJsonEl.textContent);
                if (currentVariant && currentVariant.price) {
                    return currentVariant.price; // Already in cents
                }
            } catch (e) {
                console.error('Error parsing current variant JSON:', e);
            }
        }

        return 0;
    }

    /**
     * Update product price based on quantity and current variant price
     */
    function updateProductPrice( variant = {} ) {
        const quantityInput = document.querySelector('input[name="quantity"]');
        const priceElement = document.querySelector('[data-product-price]');


        if (!quantityInput || !priceElement) return;

        const quantity = parseInt(quantityInput.value) || 1;

        // Get the base unit price from variant data
        const baseUnitPrice = variant?.price ?? getBaseUnitPrice();

        // Don't proceed if we couldn't determine the base price
        if (baseUnitPrice === 0) return;

        // Calculate total price
        const totalPrice = baseUnitPrice * quantity;

        // Format the price using the theme's currency formatter if available
        if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
            const formattedPrice = theme.Currency.formatMoney(totalPrice, theme.settings.moneyFormat);

            // Update the price display, preserving the "each" text if quantity is 1
            if (quantity === 1) {
                priceElement.innerHTML = formattedPrice + ' each';
            } else {
                priceElement.innerHTML = formattedPrice + ' <span style="font-size: 0.9em; opacity: 0.8;">(' + quantity + ' clubs)</span>';
            }
        } else {
            // Fallback: update with basic formatting
            const dollars = (totalPrice / 100).toFixed(2);
            if (quantity === 1) {
                priceElement.innerHTML = '$' + dollars + ' each';
            } else {
                priceElement.innerHTML = '$' + dollars + ' <span style="font-size: 0.9em; opacity: 0.8;">(' + quantity + ' clubs)</span>';
            }
        }
    }

    // Disable all form inputs in a container
    function disableFormInputs(container) {
        const inputs = container.querySelectorAll('input, select, textarea');
        inputs.forEach(input => {
            input.disabled = true;
        });
    }

    // Enable all form inputs in a container
    function enableFormInputs(container) {
        const inputs = container.querySelectorAll('input, select, textarea');
        inputs.forEach(input => {
            input.disabled = false;
        });
    }

    // Handle toggle clicks
    toggleButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();

            // Prevent toggling if in restricted mode
            if (customizationMode === 'Custom Only' || customizationMode === 'Prebuilt Only') {
                return;
            }

            const toggleValue = this.getAttribute('data-toggle');
            const currentMode = getCurrentMode();

            // Don't do anything if clicking the already active button
            if (toggleValue === currentMode) {
                return;
            }

            // Update URL with the new mode
            setUrlMode(toggleValue);

            // Update form visibility
            updateFormVisibility();
        });
    });

    /**
     * Initialize the form on page load
     */
    function initializeForm() {
        // Get the intended mode
        const intendedMode = getCurrentMode();

        // Ensure URL parameter is set correctly
        setUrlMode(intendedMode);

        // Update form visibility
        updateFormVisibility();

        // Set initial quantity
        const quantityInput = document.querySelector('input[name="quantity"]');
        if (quantityInput) {
            if (intendedMode === 'prebuilt') {
                quantityInput.value = 1;
            } else {
                updateCustomQuantity();
            }
        }
    }

    // Initialize on page load with a slight delay to ensure DOM is ready
    setTimeout(initializeForm, 50);

    const tabButtons = document.querySelectorAll('.tab-button');
    const tabPanels = document.querySelectorAll('.tab-panel');

    function switchToTab(targetTab) {
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabPanels.forEach(panel => panel.classList.remove('active'));

        const targetButton = document.querySelector(`.tab-button[data-tab="${targetTab}"]`);
        const targetPanel = document.querySelector(`[data-panel="${targetTab}"]`);

        if (targetButton && targetPanel) {
            targetButton.classList.add('active');
            targetPanel.classList.add('active');
        }
    }

    tabButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const targetTab = this.getAttribute('data-tab');
            switchToTab(targetTab);
        });
    });

    // Handle next buttons
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('tab-next-btn')) {
            e.preventDefault();
            const nextTab = e.target.getAttribute('data-next-tab');
            if (nextTab) {
                switchToTab(nextTab);
            }
        }
    });

    /**
     * Creates a brand-to-model filtering system
     * @param {Object} config - Configuration object
     * @param {string} config.brandSelector - CSS selector for brand select element
     * @param {string} config.modelSelector - CSS selector for model select element
     * @param {string} [config.imageContainerClass] - Class name for image container
     * @param {string} [config.priceElementSelector] - CSS selector for price display element
     * @param {string} [config.dataBrandAttribute='data-brand'] - Attribute name for brand filtering
     */
    function setupBrandModelFilter(config) {
        const {
            brandSelector,
            modelSelector,
            imageContainerClass,
            priceElementSelector,
            dataBrandAttribute = 'data-brand'
        } = config;

        const brandSelect = document.querySelector(brandSelector);
        const modelSelect = document.querySelector(modelSelector);

        if (!brandSelect || !modelSelect) return;

        // Create image display container if specified
        let imageContainer = null;
        if (imageContainerClass) {
            imageContainer = document.querySelector(`.${imageContainerClass}`);
            if (!imageContainer) {
                imageContainer = document.createElement('div');
                imageContainer.className = imageContainerClass;
                modelSelect.parentElement.appendChild(imageContainer);
            }
        }

        // Store all options for filtering
        const allModelOptions = Array.from(modelSelect.querySelectorAll('option:not([value=""])'));

        // Function to update displayed image and price
        function updateModelData() {
            const selectedOption = modelSelect.options[modelSelect.selectedIndex];
            const imageUrl = selectedOption?.getAttribute('data-image');
            const price = selectedOption?.getAttribute('data-price');

            // Update image if container exists
            if (imageContainer) {
                if (imageUrl && imageUrl !== '') {
                    imageContainer.innerHTML = `<img src="${imageUrl}" alt="${selectedOption.value}">`;
                    imageContainer.style.display = 'block';
                } else {
                    imageContainer.innerHTML = '';
                    imageContainer.style.display = 'none';
                }
            }

            // Update price if element exists
            if (priceElementSelector) {
                const priceElement = document.querySelector(priceElementSelector);
                if (priceElement) {
                    if (price && price !== '') {
                        priceElement.textContent = `[+${price}]`;
                    } else {
                        priceElement.textContent = '';
                    }
                }
            }
        }

        // Brand change handler
        brandSelect.addEventListener('change', function() {
            const selectedBrand = this.value;
            const currentValue = modelSelect.value;

            // Remove all options except the first one (placeholder)
            _populateSelectOptions(modelSelect, [], true);

            // Filter and add options
            let isCurrentValueAvailable = false;
            allModelOptions.forEach(option => {
                const optionBrand = option.getAttribute(dataBrandAttribute);

                // Show all if brand is empty, otherwise filter by brand
                if (selectedBrand === '' || optionBrand === selectedBrand) {
                    const newOption = option.cloneNode(true);
                    modelSelect.appendChild(newOption);

                    // Check if current value is still available
                    if (option.value === currentValue) {
                        isCurrentValueAvailable = true;
                    }
                }
            });

            // Restore value if still available, otherwise reset to empty
            modelSelect.value = isCurrentValueAvailable ? currentValue : '';

            // Update model data after filtering
            updateModelData();
        });

        // Update model data when selection changes
        modelSelect.addEventListener('change', updateModelData);

        // Initial data display on page load
        updateModelData();
    }

    // Note: Adapter brand/model filtering is now handled by initAdapterModelSelector() modal

    // Note: Ferrule brand/model filtering is now handled by initFerruleModelSelector() modal

    // Note: Adapter dexterity handling is now part of initAdapterModelSelector() modal

    // Note: Grip brand/model filtering is now handled by initGripModelSelector() modal

    // Note: Shaft brand/model filtering is now handled by initShaftModelSelector() modal

    // Summary functionality
    function updateSummary() {
        const summaryContent = document.querySelector('.summary-content');
        if (!summaryContent) return;

        const formContainer = document.querySelector('.customization-form');
        if (!formContainer) return;

        // Determine which form is currently visible
        const prebuiltForm = document.querySelector('.prebuilt-form');
        const customForm = document.querySelector('.club-customization-form');

        let activeFormContainer = null;
        if (prebuiltForm && prebuiltForm.style.display !== 'none') {
            activeFormContainer = prebuiltForm;
        } else if (customForm && customForm.style.display !== 'none') {
            activeFormContainer = customForm;
        }

        // If no active form, don't show summary
        if (!activeFormContainer) return;

        // Get all form inputs from the ACTIVE form only
        const formElements = activeFormContainer.querySelectorAll('select, input[type="text"], input[type="hidden"], textarea, input[type="radio"], input[type="checkbox"], input[type="range"]');
        const summaryItems = [];

        // Track which properties have been processed to avoid duplicates
        const processedProperties = new Set();

        formElements.forEach(element => {
            // Skip disabled inputs (they're from the hidden form)
            if (element.disabled) return;

            // Skip inputs without a name attribute (they've been cleaned by validation)
            if (!element.name) return;
            // For radio buttons, only process checked ones
            if (element.type === 'radio' && !element.checked) return;

            // For checkboxes (like Club Numbers), collect all checked values
            if (element.type === 'checkbox') {
                // Check if this checkbox group has already been processed
                const checkboxName = element.name;

                if (checkboxName.includes('Club Numbers') && !processedProperties.has('Club Numbers')) {
                    processedProperties.add('Club Numbers');
                    const allCheckboxes = activeFormContainer.querySelectorAll(`input[name="${checkboxName}"]`);
                    const checkedValues = Array.from(allCheckboxes)
                        .filter(cb => cb.checked && !cb.disabled && cb.name)
                        .map(cb => cb.value);

                    if (checkedValues.length > 0) {
                        summaryItems.push({
                            label: 'Club Numbers',
                            value: checkedValues.join(', ')
                        });
                    }
                    return;
                }

                // For other checkboxes
                if (!element.checked) return;
            }

            // Skip empty values
            if (!element.value || element.value === '') return;

            // Skip the quantity input (it's managed by club numbers)
            if (element.name === 'quantity') return;

            // Extract label from the name attribute
            // Handles both properties[Name] and properties[Name][] formats
            const nameMatch = element.name.match(/properties\[([^\]]+)\]/);

            if (!nameMatch) return;

            const label = nameMatch[1];

            // Skip properties with _ prefix (internal/hidden properties)
            if (label.startsWith('_')) return;

            // Skip if already processed (for checkbox groups)
            if (processedProperties.has(label)) return;
            processedProperties.add(label);

            let value = element.value;

            // For select elements, get the displayed text
            if (element.tagName === 'SELECT') {
                const selectedOption = element.options[element.selectedIndex];
                value = selectedOption.text;
            }

            // For hidden shaft model input, get display text from button
            if (element.type === 'hidden' && element.id === 'shaft-model-value') {
                const selectButton = document.querySelector('.shaft-model-select-button__title');
                if (selectButton && selectButton.textContent && selectButton.textContent !== 'Select option') {
                    value = selectButton.textContent;
                } else {
                    return; // Skip if no selection made
                }
            }

            // For range inputs, format the display value
            if (element.type === 'range') {
                const rangeValue = parseFloat(element.value);
                const propertyName = label;

                if (propertyName.includes('Length')) {
                    value = rangeValue > 0 ? `+${rangeValue}"` : `${rangeValue}"`;
                } else if (propertyName.includes('Weight')) {
                    value = `${rangeValue} grams`;
                } else if (propertyName.includes('Loft') || propertyName.includes('Lie')) {
                    value = `${rangeValue}°`;
                } else {
                    value = rangeValue;
                }

                // Skip if value is 0 (default/no change)
                if (rangeValue === 0) return;
            }

            summaryItems.push({ label, value });
        });

        // Build summary HTML
        if (summaryItems.length > 0) {
            const summaryHTML = summaryItems
                .map(item => `<div class="summary-item"><strong>${item.label}:</strong> ${item.value}</div>`)
                .join('');
            summaryContent.innerHTML = summaryHTML;
        } else {
            summaryContent.innerHTML = '<p>No customizations selected yet.</p>';
        }
    }

    // Update summary on any form change
    const formContainer = document.querySelector('.customization-form');
    if (formContainer) {
        formContainer.addEventListener('change', updateSummary);
        formContainer.addEventListener('input', updateSummary);

        // Initial summary update
        updateSummary();
    }

    /**
     * Initialize all range sliders with value display
     * Supports custom formatting based on the range slider's name attribute
     */
    function initializeRangeSliders() {
        const rangeSliders = document.querySelectorAll('.range-slider');

        rangeSliders.forEach(slider => {
            // Find the corresponding value display within the same form-field
            const formField = slider.closest('.form-field');
            if (!formField) return;

            const valueDisplay = formField.querySelector('.range-value-display');
            if (!valueDisplay) return;

            function updateRangeValue() {
                const value = parseFloat(slider.value);
                let formattedValue = value;

                // Format based on the property name
                const propertyName = slider.name.match(/properties\[(.+)\]/)?.[1];

                if (propertyName === 'Length') {
                    // Length: show +/- prefix for non-zero values
                    formattedValue = value > 0 ? `+${value}` : value;
                } else if (propertyName === 'Weight') {
                    // Weight: show plain number (no prefix)
                    formattedValue = value;
                }

                valueDisplay.textContent = formattedValue;
            }

            slider.addEventListener('input', updateRangeValue);

            // Initial value display
            updateRangeValue();
        });
    }

    // Initialize all range sliders
    initializeRangeSliders();

    /**
     * Initialize shaft model selector modal
     */
    function initShaftModelSelector() {
        const modalId = 'club-modal';
        const hiddenInput = document.getElementById('shaft-model-value');
        const selectButton = document.querySelector('.shaft-model-select-button');
        const shaftImageContainer = document.querySelector('.shaft-model-image');
        const optionsList = document.getElementById('shaft-options-list');
        const searchInput = document.getElementById('shaft-search-input');
        const shaftBrandSelect = document.querySelector('select[data-filter="shaft-brand"]');

        // Modal filter elements
        const modalBrandSelect = document.getElementById('modal-shaft-brand');
        const modalMaterialRadios = document.querySelectorAll('input[name="modal-shaft-material"]');
        const modalFlexRadios = document.querySelectorAll('input[name="modal-shaft-flex"]');

        // Main form filter elements
        const mainMaterialRadios = document.querySelectorAll('input[name="properties[Shaft Material]"]');
        const mainFlexRadios = document.querySelectorAll('input[name="properties[Shaft Flex]"]');

        if (!window.clubShaftProducts || !optionsList) return;

        let selectedShaft = null;

        // Clear the current selection
        function clearSelection() {
            hiddenInput && (hiddenInput.value = '');
            const variantInput = document.getElementById('shaft-model-variant-id');
            variantInput && (variantInput.value = '');
            selectButton && (selectButton.innerHTML = `
                <div class="model-select-button__placeholder">Select option</div>
                <div class="model-select-button__dropdown-icon">${_dropdownSvg}</div>
            `);
            shaftImageContainer && (shaftImageContainer.innerHTML = '', shaftImageContainer.style.display = 'none');
            selectedShaft = null;
            hiddenInput?.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Setup mirroring between main form and modal
        function setupMirrorSync() {
            // Sync Material: Main -> Modal (no dispatch to avoid triggering main form handlers)
            _syncRadioGroups(mainMaterialRadios, modalMaterialRadios, renderOptions, false);
            // Sync Material: Modal -> Main (dispatch to trigger main form handlers)
            _syncRadioGroups(modalMaterialRadios, mainMaterialRadios, renderOptions, true);

            // Sync Flex: Main -> Modal (no dispatch to avoid triggering main form handlers)
            _syncRadioGroups(mainFlexRadios, modalFlexRadios, renderOptions, false);
            // Sync Flex: Modal -> Main (dispatch to trigger main form handlers)
            _syncRadioGroups(modalFlexRadios, mainFlexRadios, renderOptions, true);

            // Sync Brand: Main -> Modal
            if (shaftBrandSelect && modalBrandSelect) {
                shaftBrandSelect.addEventListener('change', function() {
                    modalBrandSelect.value = this.value;
                    clearSelection(); // Reset selection when brand changes
                    renderOptions();
                });

                // Sync Brand: Modal -> Main
                modalBrandSelect.addEventListener('change', function() {
                    shaftBrandSelect.value = this.value;
                    shaftBrandSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    clearSelection(); // Reset selection when brand changes
                    renderOptions();
                });
            }

            // Initial sync when modal opens
            syncModalFilters();
        }

        // Sync modal filters with main form values
        function syncModalFilters() {
            // Sync Material
            const checkedMaterial = _getCheckedRadioValue(mainMaterialRadios);
            if (checkedMaterial) {
                _setRadioByValue(modalMaterialRadios, checkedMaterial);
            }

            // Sync Flex
            const checkedFlex = _getCheckedRadioValue(mainFlexRadios);
            if (checkedFlex) {
                _setRadioByValue(modalFlexRadios, checkedFlex);
            }

            // Sync Brand
            if (shaftBrandSelect && modalBrandSelect) {
                modalBrandSelect.value = shaftBrandSelect.value;
            }
        }

        // Get currently selected filters
        function getSelectedFilters() {
            return {
                material: _getCheckedRadioValue(modalMaterialRadios),
                flex: _getCheckedRadioValue(modalFlexRadios),
                brand: modalBrandSelect?.value || ''
            };
        }

        // Get available brands based on current material/flex filters
        function getAvailableBrands() {
            const filters = getSelectedFilters();
            const availableBrands = new Set();

            window.clubShaftProducts.forEach(shaft => {
                // Check if shaft matches material filter
                const matchesMaterial = !filters.material || shaft.material === filters.material;

                // Check if shaft matches flex filter
                const matchesFlex = !filters.flex || shaft.flex === filters.flex;

                // If shaft matches both filters, add its brand to available brands
                if (matchesMaterial && matchesFlex) {
                    availableBrands.add(shaft.vendor);
                }
            });

            return Array.from(availableBrands).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
        }

        // Update brand dropdown options based on available brands
        function updateBrandOptions() {
            if (!modalBrandSelect) return;

            const availableBrands = getAvailableBrands();
            const currentBrand = modalBrandSelect.value;

            // Populate brand select with only available brands
            _populateSelectOptions(modalBrandSelect, availableBrands, true);

            // Also update main form brand select if it exists
            if (shaftBrandSelect) {
                _populateSelectOptions(shaftBrandSelect, availableBrands, true);
            }

            // Check if currently selected brand is still available
            if (currentBrand && availableBrands.includes(currentBrand)) {
                modalBrandSelect.value = currentBrand;
                if (shaftBrandSelect) {
                    shaftBrandSelect.value = currentBrand;
                }
            } else {
                // Reset brand selection if no longer available
                modalBrandSelect.value = '';
                if (shaftBrandSelect) {
                    shaftBrandSelect.value = '';
                }
            }
        }

        // Render options in modal
        function renderOptions(filter = '') {
            // Update brand options first based on material/flex filters
            updateBrandOptions();

            const filters = getSelectedFilters();

            const filteredShafts = window.clubShaftProducts.filter(shaft => {
                // Filter by brand
                if (filters.brand && shaft.vendor !== filters.brand) {
                    return false;
                }

                // Filter by material metafield
                if (filters.material && shaft.material !== filters.material) {
                    return false;
                }

                // Filter by flex metafield
                if (filters.flex && shaft.flex !== filters.flex) {
                    return false;
                }

                // Filter by search term
                if (filter) {
                    const searchTerm = filter.toLowerCase();
                    return shaft.title.toLowerCase().includes(searchTerm) ||
                           shaft.vendor.toLowerCase().includes(searchTerm);
                }

                return true;
            });

            if (filteredShafts.length === 0) {
                optionsList.innerHTML = '<div class="no-results">No shafts found</div>';
                return;
            }

            optionsList.innerHTML = filteredShafts.map(shaft => `
                <div class="model-option shaft-option" data-shaft-title="${_escapeHtmlAttribute(shaft.title)}">
                    <div class="model-option__image">
                        ${shaft.image ? `<img src="${_escapeHtmlAttribute(shaft.image)}" alt="${_escapeHtmlAttribute(shaft.title)}">` : '<div class="no-image">No image</div>'}
                    </div>
                    <div class="model-option__info">
                        <div class="model-option__title-group">
                            <div class="model-option__title">${shaft.title}</div>
                            <div class="model-option__vendor">${shaft.vendor}</div>
                        </div>
                        <div class="model-option__price">[+${shaft.priceFormatted}]</div>
                    </div>
                </div>
            `).join('');

            // Add click handlers
            optionsList.querySelectorAll('.shaft-option').forEach(option => {
                option.addEventListener('click', function() {
                    const shaftTitle = this.getAttribute('data-shaft-title');
                    selectShaft(shaftTitle);
                });
            });
        }

        // Update shaft button display with quantity-aware pricing
        function updateShaftButtonDisplay() {
            if (!selectButton || !selectedShaft) return;
            const qty = parseInt(document.querySelector('input[name="quantity"]')?.value) || 1;
            const img = selectedShaft.image ? `<img src="${selectedShaft.image}" alt="${selectedShaft.title}">` : '';
            let price = `[+${selectedShaft.priceFormatted} each]`;
            if (qty > 1) {
                const total = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((selectedShaft.price * qty) / 100);
                price += `<div class="model-select-button__total">(${qty} × ${selectedShaft.priceFormatted} = ${total})</div>`;
            }
            selectButton.innerHTML = `
                <div class="model-select-button__image">${img}</div>
                <div class="model-select-button__info">
                    <div class="model-select-button__title-group">
                        <div class="model-select-button__title">${selectedShaft.title}</div>
                        <div class="model-select-button__vendor">${selectedShaft.vendor}</div>
                    </div>
                    <div class="model-select-button__price">${price}</div>
                </div>
                <div class="model-select-button__dropdown-icon">${_dropdownSvg}</div>
            `;
        }

        // Select a shaft
        function selectShaft(shaftTitle) {
            selectedShaft = window.clubShaftProducts.find(s => s.title === shaftTitle);
            if (!selectedShaft) return;
            hiddenInput && (hiddenInput.value = selectedShaft.title);
            const variantInput = document.getElementById('shaft-model-variant-id');
            variantInput && selectedShaft.variantId && (variantInput.value = selectedShaft.variantId);
            selectButton && updateShaftButtonDisplay();
            if (shaftImageContainer) {
                shaftImageContainer.innerHTML = selectedShaft.image ? `<img src="${selectedShaft.image}" alt="${selectedShaft.title}">` : '';
                shaftImageContainer.style.display = selectedShaft.image ? 'block' : 'none';
            }
            window.closeModal(modalId);
            hiddenInput?.dispatchEvent(new Event('change', { bubbles: true }));
        }

        searchInput?.addEventListener('input', () => renderOptions(searchInput.value));

        // Listen for brand/material/flex changes to clear selection if shaft is no longer available
        function checkSelectionValidity() {
            if (!selectedShaft) return;
            const filters = getSelectedFilters();
            const titleLower = selectedShaft.title.toLowerCase();
            const isValid = !(
                (filters.brand && selectedShaft.vendor !== filters.brand) ||
                (filters.material && !titleLower.includes(filters.material.toLowerCase())) ||
                (filters.flex && !titleLower.includes(filters.flex.toLowerCase()))
            );
            if (!isValid) clearSelection();
        }

        // Listen for main form changes to check validity
        shaftBrandSelect?.addEventListener('change', checkSelectionValidity);
        mainMaterialRadios.forEach(r => r.addEventListener('change', checkSelectionValidity));
        mainFlexRadios.forEach(r => r.addEventListener('change', checkSelectionValidity));

        // Initial render when modal opens
        selectButton?.addEventListener('click', () => {
            syncModalFilters();
            renderOptions();
            searchInput && (searchInput.value = '');
            setTimeout(() => searchInput?.focus(), 100);
        });

        setupMirrorSync();

        document.querySelector('input[name="quantity"]')?.addEventListener('change', () => {
            selectedShaft && updateShaftButtonDisplay();
        });

        renderOptions();
    }

    // Note: fetchCollectionFeed is now in club-customization-util.js

    /**
     * Load club shaft products and populate vendor dropdowns
     * @param {string} collectionHandle - The collection handle for shaft products
     */
    async function loadClubShaftProducts(collectionHandle) {
        if (!collectionHandle) {
            console.warn('No collection handle provided for club shaft products');
            return;
        }

        const { products, vendors } = await fetchCollectionFeed(collectionHandle);

        // Set global variable for backward compatibility
        window.clubShaftProducts = products;

        // Filter vendors to only include those with products that have material or flex
        const validVendors = vendors.filter(vendor => {
            return products.some(product =>
                product.vendor === vendor && (product.material || product.flex)
            );
        }).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));


        // Populate vendor dropdowns with filtered vendors
        const shaftBrandSelect = document.getElementById('shaft-brand-select');
        const modalShaftBrandSelect = document.getElementById('modal-shaft-brand');

        // Populate both vendor dropdowns
        [shaftBrandSelect, modalShaftBrandSelect].forEach(select => {
            if (select) {
                _populateSelectOptions(select, validVendors, true);
            }
        });

        // Trigger event to notify that products are loaded
        window.dispatchEvent(new CustomEvent('clubShaftProductsLoaded', {
            detail: {
                products: products,
                vendors: validVendors
            }
        }));
    }

    // Initialize club shaft products if collection handle is provided
    const clubShaftCollectionHandle = document.querySelector('[data-club-shaft-collection]')?.getAttribute('data-club-shaft-collection');
    if (clubShaftCollectionHandle) {
        loadClubShaftProducts(clubShaftCollectionHandle);
    }

    /**
     * Load grip products and populate vendor dropdowns
     * Checks for variant override first (for putters), then falls back to collection
     * @param {string} collectionHandle - The collection handle for grip products
     * @param {string} customizationType - The customization type (e.g., 'putters' for putter grips)
     * @param {string} productHandle - The product handle (optional, for putter grip overrides)
     * @param {string|number} variantId - The variant ID (optional, for putter grip overrides)
     */
    async function loadGripProducts(collectionHandle, customizationType, productHandle = null, variantId = null) {
        if (!collectionHandle) {
            console.warn('No collection handle provided for grip products');
            return;
        }

        try {
            let transformedProducts = [];
            let sortedVendors = [];
            let isOverride = false;

            // For putters, check for variant override grips first
            if (customizationType === 'putters' && productHandle && variantId) {
                const { fetchVariantOverrideProducts, convertVariantsToProducts } = window.clubCustomizationUtils || {};

                if (fetchVariantOverrideProducts && convertVariantsToProducts) {
                    const { override_grips } = await fetchVariantOverrideProducts(productHandle, variantId);

                    if (override_grips && Array.isArray(override_grips) && override_grips.length > 0) {
                        transformedProducts = convertVariantsToProducts(override_grips);
                        sortedVendors = [...new Set(transformedProducts.map(p => p.vendor).filter(Boolean))]
                            .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
                        isOverride = true;
                        console.log('Using variant override grips:', transformedProducts.length, 'products');
                    }
                }
            }

            // If no override products, fall back to collection feed
            if (transformedProducts.length === 0) {
                let allProducts = [];
                let allVendors = [];
                let currentPage = 1;
                let totalPages = 1;

                // Build the filter query parameter based on customization type
                // For putters, we want Putter Grips; for everything else, exclude Putter Grips
                const filterParam = customizationType === 'putters'
                    ? '&type=Putter+Grips'
                    : '&exclude_type=Putter+Grips';

                // Fetch all pages
                do {
                    const response = await fetch(`/collections/${collectionHandle}?view=feed&page=${currentPage}${filterParam}`);

                    if (!response.ok) {
                        throw new Error(`Failed to fetch grip collection feed: ${response.status}`);
                    }

                    const data = await response.json();

                    // Accumulate products from this page
                    allProducts = allProducts.concat(data.products);

                    // Get vendors from first page (they're the same across all pages)
                    if (currentPage === 1) {
                        allVendors = data.vendors || [];
                        totalPages = data.pagination?.total_pages || 1;
                    }

                    currentPage++;
                } while (currentPage <= totalPages);

                // Transform all products into the expected format
                transformedProducts = allProducts.flatMap(product =>
                    product.variants.map(variant => ({
                        title: variant.title === 'Default Title'
                            ? product.title
                            : `${product.title} - ${variant.title}`,
                        vendor: product.vendor,
                        variantId: variant.id,
                        price: parseFloat(variant.price) * 100, // Convert to cents
                        priceFormatted: new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD'
                        }).format(variant.price),
                        image: variant.metafields?.customization_thumbnail?.url ||
                               (product.images.find(img => img.url)?.url || product.featured_image?.url || '')
                    }))
                );

                // Sort vendors alphabetically (case-insensitive)
                sortedVendors = allVendors.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
                console.log('Using collection feed grips:', transformedProducts.length, 'products');
            }

            // Set global variable for grip products
            window.gripProducts = transformedProducts;

            // Populate vendor dropdowns
            const gripBrandSelect = document.getElementById('grip-brand-select');
            const modalGripBrandSelect = document.getElementById('modal-grip-brand');

            [gripBrandSelect, modalGripBrandSelect].forEach(select => {
                if (select) {
                    _populateSelectOptions(select, sortedVendors, true);
                }
            });

            // Trigger event to notify that products are loaded
            window.dispatchEvent(new CustomEvent('gripProductsLoaded', {
                detail: {
                    products: transformedProducts,
                    vendors: sortedVendors,
                    isOverride: isOverride
                }
            }));
        } catch (error) {
            console.error('Error loading grip products:', error);
        }
    }

    // Initialize grip products if collection handle is provided
    const gripCollectionEl = document.querySelector('[data-grip-collection]');
    if (gripCollectionEl) {
        const gripCollectionHandle = gripCollectionEl.getAttribute('data-grip-collection');
        const gripCustomizationType = gripCollectionEl.getAttribute('data-grip-customization-type');
        const gripProductHandle = gripCollectionEl.getAttribute('data-product-handle');
        const gripVariantId = gripCollectionEl.getAttribute('data-variant-id');
        loadGripProducts(gripCollectionHandle, gripCustomizationType, gripProductHandle, gripVariantId);
    }

    // Listen for custom event to load grip products dynamically
    window.addEventListener('loadGripCollection', async (event) => {
        const { collectionHandle, customizationType, productHandle, variantId } = event.detail;
        if (collectionHandle) {
            await loadGripProducts(collectionHandle, customizationType, productHandle, variantId);
            // Re-initialize grip model selector after products are loaded
            if (window.gripProducts && window.gripProducts.length > 0) {
                initGripModelSelector();
            }
        }
    });

    // Initialize grip model selector when products are loaded
    window.addEventListener('gripProductsLoaded', () => {
        if (window.gripProducts) {
            initGripModelSelector();
        }
    });

    // Listen for custom event to load shaft products dynamically
    window.addEventListener('loadClubShaftCollection', async (event) => {
        const { collectionHandle } = event.detail;
        if (collectionHandle) {
            await loadClubShaftProducts(collectionHandle);
            // Re-initialize shaft model selector after products are loaded
            if (window.clubShaftProducts && window.clubShaftProducts.length > 0) {
                initShaftModelSelector();
            }
        }
    });

    // Initialize shaft model selector
    window.addEventListener('clubShaftProductsLoaded', () => {
        if (window.clubShaftProducts) {
            initShaftModelSelector();
        }
    });

    /**
     * Prevent interaction with required club number checkboxes
     */
    function initRequiredClubNumberProtection() {
        const requiredClubOptions = document.querySelectorAll('.checkbox-group .checkbox-option.required-club');

        requiredClubOptions.forEach(label => {
            const checkbox = label.querySelector('input[type="checkbox"]');

            // Prevent click events on the label
            label.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
            });

            // Prevent any changes to the checkbox
            if (checkbox) {
                checkbox.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                });

                checkbox.addEventListener('change', function() {
                    // Always keep it checked
                    this.checked = true;
                });
            }
        });
    }

    /**
     * Initialize club number quantity sync
     * Listens for changes to club number checkboxes and updates quantity
     */
    function initClubNumberQuantitySync() {
        const clubNumberCheckboxes = document.querySelectorAll('input[name="properties[Club Numbers][]"]');
        
        if (!clubNumberCheckboxes.length) return;

        // Listen for changes on all club number checkboxes
        clubNumberCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', updateCustomQuantity);
        });

        // Initial update on page load
        updateCustomQuantity();
    }

    // Initialize required club number protection
    initRequiredClubNumberProtection();

    // Initialize club number quantity sync
    initClubNumberQuantitySync();

    /**
     * Initialize select elements with image display and variant ID tracking
     * Works with .form-field-with-image containers
     */
    function initSelectWithImageAndId() {
        const formFields = document.querySelectorAll('.form-field-with-image');

        formFields.forEach(formField => {
            const selectElement = formField.querySelector('select');
            const imageContainer = formField.querySelector('.select-image');
            const hiddenIdInput = formField.querySelector('input[type="hidden"]');

            if (!selectElement) return;

            selectElement.addEventListener('change', function() {
                const selectedOption = this.options[this.selectedIndex];
                const variantId = selectedOption.getAttribute('data-variant-id');
                const imageUrl = selectedOption.getAttribute('data-image');

                // Update hidden variant ID field
                if (hiddenIdInput && variantId) {
                    hiddenIdInput.value = variantId;
                } else if (hiddenIdInput) {
                    hiddenIdInput.value = '';
                }

                // Update image display
                if (imageContainer) {
                    if (imageUrl && imageUrl !== '' && imageUrl !== 'null') {
                        imageContainer.innerHTML = `<img src="${imageUrl}" alt="${selectedOption.value}">`;
                        imageContainer.style.display = 'block';
                    } else {
                        imageContainer.innerHTML = '';
                        imageContainer.style.display = 'none';
                    }
                }
            });

            // Trigger initial update if there's a pre-selected option
            if (selectElement.value) {
                selectElement.dispatchEvent(new Event('change'));
            }
        });
    }

    // Initialize all select elements with image and ID tracking
    initSelectWithImageAndId();

    /**
     * Sync Set Makeup selection with variant input (bidirectional)
     */
    function initSetMakeupVariantSync() {
        const setMakeupSelect = document.querySelector('select[name="properties[Set Makeup]"]');
        _syncSelectWithVariant(setMakeupSelect, 'Set Makeup');
    }

    // Initialize Set Makeup variant sync
    initSetMakeupVariantSync();

    /**
     * Listen for variant and quantity changes and update the product price
     */
    function initVariantPriceSync() {
        // Capture the current mode before any variant changes
        let modeBeforeVariantChange = null;

        // Store mode before variant changes (if we're in Custom/Prebuilt mode)
        document.addEventListener('variant:change', function() {
            // Only track mode for Custom/Prebuilt mode, not restricted modes
            if (customizationMode === 'Custom/Prebuilt' && !modeBeforeVariantChange) {
                modeBeforeVariantChange = getCurrentMode();
            }
        }, true); // Use capture phase to run before the main handler

        // Listen for variant:change dispatch from theme.js
        document.addEventListener('variant:change', function(event) {
            const { variant } = event.detail;
            if (!variant) return;

            updateProductPrice(variant);

            // Only preserve mode for Custom/Prebuilt mode (skip for restricted modes)
            if (customizationMode !== 'Custom/Prebuilt') {
                return;
            }

            // Preserve the custom/prebuilt mode after variant change
            // This prevents the variant change from interfering with form visibility
            if (!isUpdatingFromVariantChange && modeBeforeVariantChange) {
                isUpdatingFromVariantChange = true;

                setTimeout(() => {
                    const urlParams = new URLSearchParams(window.location.search);
                    const urlCustomParam = urlParams.get('custom');

                    // If the custom parameter is missing or incorrect, restore it to the mode we had before
                    if (!urlCustomParam || (urlCustomParam !== modeBeforeVariantChange)) {
                        setUrlMode(modeBeforeVariantChange);
                    }

                    // Ensure form visibility is still correct
                    updateFormVisibility();

                    // Reset flag and captured mode
                    isUpdatingFromVariantChange = false;
                    modeBeforeVariantChange = null;
                }, 100);
            } else {
                // Reset captured mode if we're not updating
                modeBeforeVariantChange = null;
            }
        });

        // Listen for quantity changes
        const quantityInput = document.querySelector('input[name="quantity"]');
        if (quantityInput) {
            quantityInput.addEventListener('change', function(e) {
                updateProductPrice();
            });
        }
    }

    // Initialize variant price sync
    initVariantPriceSync();

    // Note: _escapeHtmlAttribute, _dropdownSvg, and initModelSelector are now in club-customization-util.js

    /**
     * Initialize generic model selector (for Ferrule, Adapter)
     * Wrapper around initModelSelector
     */
    function initGenericModelSelector(config) {
        return initModelSelector({ ...config, productsDataId: config.productsDataId });
    }

    /**
     * Initialize Grip Model Selector using unified initModelSelector
     */
    function initGripModelSelector() {
        if (!window.gripProducts) return;
        initModelSelector({
            modalId: 'grip-modal',
            hiddenInputId: 'grip-model-value',
            variantIdInputId: 'grip-model-variant-id',
            selectButtonClass: 'grip-model-select-button',
            optionsListId: 'grip-options-list',
            searchInputId: 'grip-search-input',
            brandSelectId: 'grip-brand-select',
            modalBrandSelectId: 'modal-grip-brand',
            optionClass: 'grip-option',
            windowDataKey: 'gripProducts'
        });
    }

    /**
     * Initialize Ferrule Model Selector
     */
    function initFerruleModelSelector() {
        initGenericModelSelector({
            modalId: 'ferrule-modal',
            hiddenInputId: 'ferrule-model-value',
            variantIdInputId: 'ferrule-model-variant-id',
            selectButtonClass: 'ferrule-model-select-button',
            imageContainerClass: 'ferrule-model-image',
            optionsListId: 'ferrule-options-list',
            searchInputId: 'ferrule-search-input',
            brandSelectId: 'ferrule-brand-select',
            modalBrandSelectId: 'modal-ferrule-brand',
            productsDataId: 'ferrule-products-data',
            optionClass: 'ferrule-option'
        });
    }

    /**
     * Initialize Adapter Model Selector
     */
    function initAdapterModelSelector() {
        initGenericModelSelector({
            modalId: 'adapter-modal',
            hiddenInputId: 'adapter-model-value',
            variantIdInputId: 'adapter-model-variant-id',
            selectButtonClass: 'adapter-model-select-button',
            imageContainerClass: 'adapter-model-image',
            optionsListId: 'adapter-options-list',
            searchInputId: 'adapter-search-input',
            brandSelectId: 'adapter-brand-select',
            modalBrandSelectId: 'modal-adapter-brand',
            productsDataId: 'adapter-products-data',
            optionClass: 'adapter-option'
        });

        // Handle adapter dexterity based on adapter model selection
        const adapterValueInput = document.getElementById('adapter-model-value');
        const dexterityRadios = document.querySelectorAll('input[name="properties[Adapter Dexterity]"]');

        if (!adapterValueInput || dexterityRadios.length === 0) return;

        function updateAdapterDexterity() {
            // Get the selected adapter's dexterity data
            const productsDataEl = document.getElementById('adapter-products-data');
            if (!productsDataEl) return;

            let products = [];
            try {
                products = JSON.parse(productsDataEl.textContent);
            } catch (e) {
                console.error('Error parsing adapter products data:', e);
                return;
            }

            // Find the selected product
            const selectedTitle = adapterValueInput.value;
            const selectedProduct = products.find(p => p.title === selectedTitle);

            // Parse the dexterity array
            let availableDexterities = [];
            if (selectedProduct && selectedProduct.dexterity) {
                try {
                    availableDexterities = Array.isArray(selectedProduct.dexterity)
                        ? selectedProduct.dexterity
                        : JSON.parse(selectedProduct.dexterity);
                } catch (e) {
                    availableDexterities = [];
                }
            }

            // Update radio buttons
            dexterityRadios.forEach(radio => {
                const radioValue = radio.value;
                const isAvailable = availableDexterities.length === 0 || availableDexterities.includes(radioValue);

                // Enable/disable radio button
                radio.disabled = !isAvailable;

                // Update parent label styling
                const parentLabel = radio.closest('.radio-option');
                if (parentLabel) {
                    if (isAvailable) {
                        parentLabel.classList.remove('disabled');
                    } else {
                        parentLabel.classList.add('disabled');
                        // Uncheck if currently selected
                        if (radio.checked) {
                            radio.checked = false;
                        }
                    }
                }
            });

            // Auto-select first available option if none selected
            const anyChecked = Array.from(dexterityRadios).some(radio => radio.checked && !radio.disabled);
            if (!anyChecked) {
                const firstAvailable = Array.from(dexterityRadios).find(radio => !radio.disabled);
                if (firstAvailable) {
                    firstAvailable.checked = true;
                }
            }
        }

        // Listen for adapter model changes
        adapterValueInput.addEventListener('change', updateAdapterDexterity);

        // Initial update on page load
        updateAdapterDexterity();
    }

    /**
     * Initialize Adapter Settings dropdown based on selected Adapter Model's vendor
     * Uses window.AdapterSettings array with case-insensitive lookup and default fallback
     *
     * Two modes:
     * 1. Club form (has club-adapter-brand attribute): Uses product-override-model first, then club-adapter-brand, then default
     * 2. Shaft form (no club-adapter-brand attribute): Uses adapter's override_adapter_settings, then adapter vendor, then default
     */
    function initAdapterSettingsSync() {
        const adapterModelInput = document.getElementById('adapter-model-value');
        const adapterSettingsSelect = document.querySelector('select[name="properties[Adapter Settings]"]');
        const adapterProductsDataEl = document.getElementById('adapter-products-data');

        if (!adapterSettingsSelect) return;

        // Check if this is the club form (has club-adapter-brand attribute)
        const clubAdapterBrand = adapterSettingsSelect.getAttribute('club-adapter-brand');
        const productOverrideModel = adapterSettingsSelect.getAttribute('product-override-model');
        const isClubForm = clubAdapterBrand !== null;

        // Parse adapter products data (only needed for shaft form)
        let adapterProducts = [];
        if (adapterProductsDataEl && !isClubForm) {
            try {
                adapterProducts = JSON.parse(adapterProductsDataEl.textContent);
            } catch (e) {
                console.error('Error parsing adapter products data:', e);
            }
        }

        /**
         * Get adapter data from selected model title
         * @param {string} modelTitle - The selected adapter model title
         * @returns {object|null} The adapter product data
         */
        function getAdapterFromModel(modelTitle) {
            if (!modelTitle || !adapterProducts.length) return null;
            return adapterProducts.find(p => p.title === modelTitle) || null;
        }

        /**
         * Find config from window.AdapterSettings by model name (case-insensitive)
         * @param {string} modelName - The model name to search for
         * @returns {object|null} The matching config or null
         */
        function findConfigByModel(modelName) {
            if (!window.AdapterSettings || !Array.isArray(window.AdapterSettings)) return null;
            if (!modelName) return null;

            const modelLower = modelName.toLowerCase();
            return window.AdapterSettings.find(
                c => c.model && c.model.toLowerCase() === modelLower
            ) || null;
        }

        /**
         * Get the default config from window.AdapterSettings
         * @returns {object|null} The default config or null
         */
        function getDefaultConfig() {
            if (!window.AdapterSettings || !Array.isArray(window.AdapterSettings)) return null;
            return window.AdapterSettings.find(
                c => c.model && c.model.toLowerCase() === 'default'
            ) || null;
        }

        /**
         * Populate adapter settings dropdown based on config
         * @param {object} config - The config object with adapterSettings and defaultValue
         */
        function populateFromConfig(config) {
            const settings = config?.adapterSettings || [];
            const defaultValue = config?.defaultValue || '';

            // Clear current options
            adapterSettingsSelect.innerHTML = '';

            // Populate with new options
            let defaultIndex = 0;
            settings.forEach((setting, index) => {
                const option = document.createElement('option');
                option.value = setting;
                option.textContent = setting;
                // Check if this is the default value (case-insensitive)
                if (defaultValue && setting.toLowerCase() === defaultValue.toLowerCase()) {
                    defaultIndex = index;
                }
                adapterSettingsSelect.appendChild(option);
            });

            // Select the default option
            if (adapterSettingsSelect.options.length > 0) {
                adapterSettingsSelect.selectedIndex = defaultIndex;
            }

            // Trigger change event for summary update
            adapterSettingsSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        /**
         * Populate adapter settings for club form (using attributes on the select element)
         */
        function populateAdapterSettingsForClubForm() {
            let config = null;

            // Priority 1: Use product-override-model attribute if it has a valid value
            if (productOverrideModel && productOverrideModel !== '' && productOverrideModel !== 'null') {
                // Parse the JSON value if needed (it comes from Liquid json filter)
                let overrideModelValue = productOverrideModel;
                try {
                    // Try to parse in case it's a JSON string
                    const parsed = JSON.parse(productOverrideModel);
                    if (parsed) overrideModelValue = parsed;
                } catch (e) {
                    // Not JSON, use as-is
                }

                if (overrideModelValue) {
                    config = findConfigByModel(overrideModelValue);
                }
            }

            // Priority 2: Use club-adapter-brand attribute
            if (!config && clubAdapterBrand && clubAdapterBrand !== '') {
                config = findConfigByModel(clubAdapterBrand);
            }

            // Priority 3: Fall back to default
            if (!config) {
                config = getDefaultConfig();
            }

            populateFromConfig(config);
        }

        /**
         * Populate adapter settings for shaft form (based on selected adapter model)
         * @param {string} modelTitle - The selected adapter model title
         */
        function populateAdapterSettingsForShaftForm(modelTitle) {
            const selectedAdapter = getAdapterFromModel(modelTitle);
            let config = null;

            // Priority 1: Use override_adapter_settings from the selected adapter if available
            if (selectedAdapter?.override_adapter_settings) {
                config = {
                    model: selectedAdapter.override_adapter_settings.model,
                    adapterSettings: selectedAdapter.override_adapter_settings.adapter_settings,
                    defaultValue: selectedAdapter.override_adapter_settings.defaultValue
                };
            }
            // Priority 2: Use window.AdapterSettings based on vendor/brand
            else if (selectedAdapter?.vendor) {
                config = findConfigByModel(selectedAdapter.vendor);
            }

            // Priority 3: Fall back to default
            if (!config) {
                config = getDefaultConfig();
            }

            populateFromConfig(config);
        }

        // Initialize based on form type
        if (isClubForm) {
            // Club form: populate immediately using attributes
            populateAdapterSettingsForClubForm();
        } else {
            // Shaft form: listen for adapter model changes
            if (adapterModelInput) {
                adapterModelInput.addEventListener('change', function() {
                    populateAdapterSettingsForShaftForm(this.value);
                });

                // Initial population on page load
                populateAdapterSettingsForShaftForm(adapterModelInput.value || '');
            }
        }
    }

    // Initialize all model selectors
    // Note: initGripModelSelector() is called via gripProductsLoaded event after dynamic loading
    initFerruleModelSelector();
    initAdapterModelSelector();

    // Initialize adapter settings sync
    initAdapterSettingsSync();

    // Listen for adapter products filtered event (from club-customization-2.js)
    document.addEventListener('adapterProductsFiltered', function() {
        // Reinitialize adapter model selector with filtered products
        initAdapterModelSelector();
    });

    /**
     * Initialize Playing Length options based on Club Type selection
     * Updates the Playing Length dropdown when Club Type changes
     */
    function initPlayingLengthSync() {
        const clubTypeSelect = document.querySelector('select[name="properties[Club Type]"]');
        const playingLengthSelect = document.querySelector('select[name="properties[Playing Length]"]');

        if (!clubTypeSelect || !playingLengthSelect) return;

        /**
         * Get the appropriate lengths array for a given club type
         * @param {string} clubType - The selected club type
         * @returns {Array} Array of length options
         */
        function getLengthsForClubType(clubType) {
            if (!clubType || !playingLengths[clubType]) {
                return playingLengths['default'] || [];
            }
            return playingLengths[clubType];
        }

        /**
         * Find the index of the Standard option, or return 0 if not found
         * @param {Array} lengths - Array of length options
         * @returns {number} Index of standard option
         */
        function findStandardIndex(lengths) {
            const standardIndex = lengths.findIndex(length =>
                length.toLowerCase().includes('standard')
            );
            return standardIndex !== -1 ? standardIndex : 0;
        }

        /**
         * Update the Playing Length select options
         */
        function updatePlayingLengthOptions() {
            const selectedClubType = clubTypeSelect.value;
            const lengths = getLengthsForClubType(selectedClubType);

            // Clear current options
            playingLengthSelect.innerHTML = '';

            // Populate with new options
            lengths.forEach(length => {
                const option = document.createElement('option');
                option.value = length;
                option.textContent = length;
                playingLengthSelect.appendChild(option);
            });

            // Set the default selection to Standard if available, otherwise first
            const standardIndex = findStandardIndex(lengths);
            if (lengths[standardIndex]) {
                playingLengthSelect.value = lengths[standardIndex];
            }

            // Trigger change event for summary update
            playingLengthSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Listen for Club Type changes
        clubTypeSelect.addEventListener('change', updatePlayingLengthOptions);

        // Initial update on page load
        updatePlayingLengthOptions();
    }

    // Initialize Playing Length sync
    initPlayingLengthSync();

    /**
     * Initialize "No Adapter" option handling
     * When "No Adapter" is selected, hide adapter model field and skip validation
     */
    function initNoAdapterHandler() {
        const adapterBrandSelect = document.getElementById('adapter-brand-select');
        const modalAdapterBrandSelect = document.getElementById('modal-adapter-brand');
        const adapterModelField = document.getElementById('adapter-model-field');
        const adapterModelValue = document.getElementById('adapter-model-value');
        const adapterVariantId = document.getElementById('adapter-model-variant-id');
        const adapterSettingsField = document.querySelector('.form-field:has(select[name="properties[Adapter Settings]"])');
        const adapterDexterityField = document.querySelector('.form-field:has(input[name="properties[Adapter Dexterity]"])');
        const clubBuildInfoField = document.getElementById('club-build-info-field');

        if (!adapterBrandSelect || !adapterModelField) return;

        function handleNoAdapterSelection(selectedValue) {
            const isNoAdapter = selectedValue === '__no_adapter__';

            if (isNoAdapter) {
                // Hide adapter model field and remove required class
                adapterModelField.style.display = 'none';
                adapterModelField.classList.remove('required');

                // Remove required from club build info field when no adapter selected
                if (clubBuildInfoField) {
                    clubBuildInfoField.classList.remove('required');
                }

                // Set placeholder values indicating no adapter
                if (adapterModelValue) {
                    adapterModelValue.value = 'No Adapter';
                }
                if (adapterVariantId) {
                    adapterVariantId.value = '';
                }

                // Hide and disable adapter settings and dexterity fields
                if (adapterSettingsField) {
                    adapterSettingsField.style.display = 'none';
                    const settingsSelect = adapterSettingsField.querySelector('select');
                    if (settingsSelect) settingsSelect.disabled = true;
                }
                if (adapterDexterityField) {
                    adapterDexterityField.style.display = 'none';
                    const dexterityRadios = adapterDexterityField.querySelectorAll('input[type="radio"]');
                    dexterityRadios.forEach(radio => radio.disabled = true);
                }

                // Trigger payment button visibility update
                if (window.updatePaymentButtonsVisibility) {
                    window.updatePaymentButtonsVisibility();
                }
            } else {
                // Show adapter model field and restore required class
                adapterModelField.style.display = '';
                adapterModelField.classList.add('required');

                // Restore required on club build info field when adapter selected
                if (clubBuildInfoField) {
                    clubBuildInfoField.classList.add('required');
                }

                // Clear placeholder values if they were set to "No Adapter"
                if (adapterModelValue && adapterModelValue.value === 'No Adapter') {
                    adapterModelValue.value = '';
                }

                // Show and enable adapter settings and dexterity fields
                if (adapterSettingsField) {
                    adapterSettingsField.style.display = '';
                    const settingsSelect = adapterSettingsField.querySelector('select');
                    if (settingsSelect) settingsSelect.disabled = false;
                }
                if (adapterDexterityField) {
                    adapterDexterityField.style.display = '';
                    const dexterityRadios = adapterDexterityField.querySelectorAll('input[type="radio"]');
                    dexterityRadios.forEach(radio => radio.disabled = false);
                }

                // Trigger payment button visibility update
                if (window.updatePaymentButtonsVisibility) {
                    window.updatePaymentButtonsVisibility();
                }
            }
        }

        // Listen for changes on main brand select
        adapterBrandSelect.addEventListener('change', function() {
            handleNoAdapterSelection(this.value);
            // Sync with modal
            if (modalAdapterBrandSelect) {
                modalAdapterBrandSelect.value = this.value;
            }
        });

        // Listen for changes on modal brand select
        if (modalAdapterBrandSelect) {
            modalAdapterBrandSelect.addEventListener('change', function() {
                handleNoAdapterSelection(this.value);
                // Sync with main select
                adapterBrandSelect.value = this.value;
            });
        }

        // Initial check on page load
        handleNoAdapterSelection(adapterBrandSelect.value);
    }

    /**
     * Initialize "No Grip" option handling
     * When "No Grip" is selected, hide grip model field and skip validation
     */
    function initNoGripHandler() {
        const gripBrandSelect = document.getElementById('grip-brand-select');
        const modalGripBrandSelect = document.getElementById('modal-grip-brand');
        const gripModelField = document.getElementById('grip-model-field');
        const gripModelValue = document.getElementById('grip-model-value');
        const gripVariantId = document.getElementById('grip-model-variant-id');
        const gripLogoField = document.querySelector('.form-field:has(select[name="properties[Grip Logo]"])');
        const gripWrapsField = document.querySelector('.form-field:has(select[name="properties[Grip Wraps]"])');

        if (!gripBrandSelect || !gripModelField) return;

        function handleNoGripSelection(selectedValue) {
            const isNoGrip = selectedValue === '__no_grip__';

            if (isNoGrip) {
                // Hide grip model field and remove required class
                gripModelField.style.display = 'none';
                gripModelField.classList.remove('required');

                // Set placeholder values indicating no grip
                if (gripModelValue) {
                    gripModelValue.value = 'No Grip';
                }
                if (gripVariantId) {
                    gripVariantId.value = '';
                }

                // Hide and disable grip logo and wraps fields
                if (gripLogoField) {
                    gripLogoField.style.display = 'none';
                    const logoSelect = gripLogoField.querySelector('select');
                    if (logoSelect) logoSelect.disabled = true;
                }
                if (gripWrapsField) {
                    gripWrapsField.style.display = 'none';
                    const wrapsSelect = gripWrapsField.querySelector('select');
                    if (wrapsSelect) wrapsSelect.disabled = true;
                }

                // Trigger payment button visibility update
                if (window.updatePaymentButtonsVisibility) {
                    window.updatePaymentButtonsVisibility();
                }
            } else {
                // Show grip model field and restore required class
                gripModelField.style.display = '';
                gripModelField.classList.add('required');

                // Clear placeholder values if they were set to "No Grip"
                if (gripModelValue && gripModelValue.value === 'No Grip') {
                    gripModelValue.value = '';
                }

                // Show and enable grip logo and wraps fields
                if (gripLogoField) {
                    gripLogoField.style.display = '';
                    const logoSelect = gripLogoField.querySelector('select');
                    if (logoSelect) logoSelect.disabled = false;
                }
                if (gripWrapsField) {
                    gripWrapsField.style.display = '';
                    const wrapsSelect = gripWrapsField.querySelector('select');
                    if (wrapsSelect) wrapsSelect.disabled = false;
                }

                // Trigger payment button visibility update
                if (window.updatePaymentButtonsVisibility) {
                    window.updatePaymentButtonsVisibility();
                }
            }
        }

        // Listen for changes on main brand select
        gripBrandSelect.addEventListener('change', function() {
            handleNoGripSelection(this.value);
            // Sync with modal
            if (modalGripBrandSelect) {
                modalGripBrandSelect.value = this.value;
            }
        });

        // Listen for changes on modal brand select
        if (modalGripBrandSelect) {
            modalGripBrandSelect.addEventListener('change', function() {
                handleNoGripSelection(this.value);
                // Sync with main select
                gripBrandSelect.value = this.value;
            });
        }

        // Initial check on page load
        handleNoGripSelection(gripBrandSelect.value);
    }

    // Initialize No Adapter handler
    initNoAdapterHandler();

    // Initialize No Grip handler
    initNoGripHandler();

    // Re-initialize No Grip handler when grip products are loaded (since the dropdown is populated dynamically)
    window.addEventListener('gripProductsLoaded', (event) => {
        if(event.detail.isOverride) return 
        // Ensure "No Grip" option is preserved at the top after dynamic population
        const gripBrandSelect = document.getElementById('grip-brand-select');
        const modalGripBrandSelect = document.getElementById('modal-grip-brand');

        [gripBrandSelect, modalGripBrandSelect].forEach(select => {
            if (select && !select.querySelector('option[value="__no_grip__"]')) {
                // Add "No Grip" option after "All" if it's missing
                const allOption = select.querySelector('option[value=""]');
                if (allOption) {
                    const noGripOption = document.createElement('option');
                    noGripOption.value = '__no_grip__';
                    noGripOption.textContent = 'No Grip';
                    allOption.after(noGripOption);
                }
            }
        });

        // Re-initialize handler after products are loaded
        initNoGripHandler();
    });

    // Note: fetchVariantOverrideProducts and convertVariantsToProducts are now in club-customization-util.js
});